import React, { ReactNode } from 'react';
import { Link } from '@gatsbyjs/reach-router';

import { ProductTreatments } from '../content';

import {
  Disclaimer,
  ImageContainer,
  ProductBody,
  ProductContainer,
  ProductName,
  ProductPrice,
  ProductTreatment,
  ProductTreatmentContainer,
} from './Product.style';

export interface ProductProps {
  image: ReactNode;
  name: ReactNode;
  price?: ReactNode;
  body?: string;
  treatments?: ProductTreatments[];
  url?: string;
  disclaimer?: string;
  size?: number;
}

export const Product = ({
  image,
  name,
  price,
  body,
  treatments = [],
  url,
  disclaimer,
  size = 0,
}: ProductProps) => {
  return (
    <ProductContainer size={size}>
      {url ? (
        <Link to={url}>
          <ImageContainer>{image}</ImageContainer>
        </Link>
      ) : (
        <ImageContainer>{image}</ImageContainer>
      )}
      <ProductName>{name}</ProductName>
      {price && <ProductPrice>{price}</ProductPrice>}
      {body && <ProductBody>{body}</ProductBody>}
      <ProductTreatmentContainer>
        {treatments &&
          treatments.map((treatment) => (
            <ProductTreatment key={treatment}>{treatment}</ProductTreatment>
          ))}
      </ProductTreatmentContainer>
      {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
    </ProductContainer>
  );
};
